import styled, { css } from 'styled-components';
import { MUIconButtonStyle, labelStyle } from 'styles/base-classes';
import Button from '@material-ui/core/Button';
import BulletSVG from 'icons/bullet.svg';

export const IconWrapper = styled.div`
  flex: 0 0 2em;
  margin: 0 0.25em 0 0.25em;
`;

export const RemoveButtonWrapper = styled.div`
  flex: 0 0 2em;
  padding: 0.25em;
  margin-left: 1em;
`;

export const RemoveButton = styled(Button)`
  && {
    ${MUIconButtonStyle};
  }
`;

export const AddButton = styled(Button)``;

export const BulletIcon = styled(BulletSVG)`
  display: block;
  margin: 0.2em 0.3em;
`;

const editModeListItemStyle = css`
  background: white;
`;

export const ListItem = styled.li`
  flex: 1 1 auto;
  display: flex;
  align-items: flex-start;
  padding: 0.5em;
  border-left: 1px solid ${({ theme }) => theme.base.Mystic};
  border-right: 1px solid ${({ theme }) => theme.base.Mystic};
  border-bottom: 1px solid ${({ theme }) => theme.base.Mystic};

  ${({ editModeEnabled }) => editModeEnabled && editModeListItemStyle};
`;

export const AnnotationDetails = styled.div`
  flex: 1 1 100%;
`;

export const DateAndGroup = styled.label`
  display: block;
  font-size: 0.8125em;
  font-weight: 700;
`;

export const Text = styled.p`
  margin: 0.25em 0;
  font-size: 0.8125em;
`;

export const Title = styled.h4`
  margin: 0.25em 0;
  font-size: 0.8125em;
`;

export const Label = styled.label`
  ${labelStyle};
  margin-top: 2em;
`;



// WEBPACK FOOTER //
// ./src/components/Annotations/Annotation/Annotation.style.js